
import SelectButton from "primevue/selectbutton";
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";
import { reactive } from "vue";


interface IList {
  accountName: string;
  accountNature: string;
  expenseType: string;
  totalExpense: number;
  totalRevenue: number;
}

const EXPENSE_CATEGORIES = ['Administrative Expenses', 'Sales & Distribution Expenses', 'Finance Expenses', 'Other Expenses'];

@Options({
  title: 'Statement of Income',
  components: {
    SelectButton,
  },
})

export default class IncomeStatement extends mixins(UtilityOptions) {
  private lists: IList []  = [];
  private reportService;
  private resultTitle = "";
  private storeName = "";
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "index" },
    { label: "Statement of Income", to: "income-statement-report" },
  ];

  private searchFilters = {
      id: "",
      date1: "",
      date2: "",
      filterType: "this_month",
      storeType: "all_store",
      storeID: 0,
      basisType: "accrual",
  };

  private basisOptions = [
    { label: 'Accrual Basis', 
      value: 'accrual' 
    },
    { label: 'Cash Basis', 
      value: 'cash' 
    },
  ];

  private storeType = [
    {
      name: 'Single Store',
      value:'single_store'
    },
    {
      name: 'All Stores',
      value:'all_stores'
    }
  ];

  private brands:any = [];
  private sectors:any = [];
  private categories:any = [];
  private productTypes:any = [];

  private filterDates = [];
  private dialogTitle;
  private submitted = false;
  private filterBranch = [];

  onBasisChange(val: string) {
    if (!val) return; 
    this.loadList();
  }

  //CALLING WHENEVER COMPONENT LOADS
  created() {
    this.reportService = new StoreReports();
  }
  
   //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.storeList();
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {       
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }

  storeList() {
    this.loading = true;
    this.searchFilters.storeType = 'single_store';

    this.reportService.getFilterList().then((res) => {
      this.filterBranch = res.branches.map(b => ({
        ...b,
        id: Number(b.id)
      }));

      this.filterDates = res.datesList;

      this.searchFilters.storeID = Number(res.current_branch_id);

      this.loadList();
    });
  }
 
  // USED TO GET SEARCHED ASSOCIATE
  loadList() {
      this.loading = true;
      
      this.searchFilters.storeType = (this.searchFilters.storeID && this.searchFilters.storeID !== 0)
          ? 'single_store'
          : 'all_stores';

      this.reportService.incomeStatement(this.searchFilters).then((res) => {
          const data = this.camelizeKeys(res);
          this.resultTitle = data.resultTitle;
          this.storeName = data.storeName;
          this.lists = data.record;
          this.loading = false;
      });
      this.productDialog = false;
  }

  get allRevenueAccounts()
  {
    const a = this.lists.filter(e => e.accountNature == 'Revenue');
    return a;
  }

  // Rolls up all operating expense accounts into the 4 fixed categories
  // (Administrative, Selling, Finance, Other). 'Cost of Goods' and
  // 'Inventory Losses' are excluded here - they're part of Gross Profit.
  get expenseCategoryTotals()
  {
    const totals = EXPENSE_CATEGORIES.map(category => ({ category, total: 0 }));

    this.lists.forEach(e => {
      if (e.accountNature !== 'Expense') return;

      const match = totals.find(t => t.category === e.expenseType);
      if (match) {
        match.total += Number(e.totalExpense);
      }
    });

    return totals;
  }

  // Same as expenseCategoryTotals but only includes categories with a
  // nonzero balance, so empty categories don't clutter the statement.
  get nonZeroExpenseCategoryTotals()
  {
    return this.expenseCategoryTotals.filter(c => Number(c.total) !== 0);
  }

  get sumRevenue()
  {
    let total = 0;

    this.lists.forEach(e => {
      if(e.accountNature == 'Revenue')
      {
        total = total + Number(e.totalRevenue);
      }
    });
    return total;
  }

  // Cost of Goods account, expenseType = 'Cost of Goods'
  get costOfGoods()
  {
    let total = 0;
    this.lists.forEach(e => {
      if (e.accountNature == 'Expense' && e.expenseType == 'Cost of Goods') {
        total += Number(e.totalExpense);
      }
    });
    return total;
  }

  // Stock Loss account, expenseType = 'Inventory Losses'
  get inventoryLosses()
  {
    let total = 0;
    this.lists.forEach(e => {
      if (e.accountNature == 'Expense' && e.expenseType == 'Inventory Losses') {
        total += Number(e.totalExpense);
      }
    });
    return total;
  }

  // Total Cost of Sales = Cost of Goods + Inventory Losses
  get totalCostOfSales()
  {
    return this.costOfGoods + this.inventoryLosses;
  }

  // Gross Profit = Revenue - Total Cost of Sales
  get grossProfit()
  {
    return this.sumRevenue - this.totalCostOfSales;
  }

  // Sum of the 4 operating expense categories only
  get sumOperatingExpenses()
  {
    let total = 0;
    this.expenseCategoryTotals.forEach(c => {
      total += Number(c.total);
    });
    return total;
  }

  // Operational Profit = Gross Profit - Operating Expenses (the 4 categories)
  get operationalProfit()
  {
    return this.grossProfit - this.sumOperatingExpenses;
  }

  clearForFilters() {
    this.searchFilters.date1 = "";
    this.searchFilters.date2 = "";
  }

  clearSearch() {
    this.searchFilters.filterType = "None";
  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  get branchOptions() {
      return [...this.filterBranch];
  }

}
